import { z } from "zod"

export const BOX_OFFER_TICKET_BOOKS_MIN = 1
export const BOX_OFFER_TICKET_BOOKS_MAX = 99
export const BOX_OFFER_WEEKLY_PARTICIPATION_MIN = 1
export const BOX_OFFER_WEEKLY_PARTICIPATION_MAX = 99
export const BOX_OFFER_VALIDITY_MIN = 1
export const BOX_OFFER_VALIDITY_MAX = 24

export enum BoxOfferType {
  Subscription = "SUBSCRIPTION",
  DropIn = "DROP_IN",
  Trial = "TRIAL",
  TicketsBook = "TICKETS_BOOK",
  Millenium = "MILLENIUM",
}

export enum BoxOfferLiteVersion {
  DropIn = "DROP_IN",
  Trial = "TRIAL",
  Millenium = "MILLENIUM",
}

export enum BoxOfferPriceType {
  Free = "FREE",
  Paid = "PAID",
}

export enum BoxOfferWeeklyParticipationType {
  Unlimited = "UNLIMITED",
  Restricted = "RESTRICTED",
}

export const OfferAutonomousPurchase = {
  NO_ONE: "NO_ONE",
  MEMBERS: "MEMBERS",
  LEADS_AND_DROP_IN: "LEADS_AND_DROP_IN",
  PUBLIC: "PUBLIC",
}
export type OfferAutonomousPurchase = (typeof OfferAutonomousPurchase)[keyof typeof OfferAutonomousPurchase]

export enum BoxOfferInvitationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REFUSED = "REFUSED",
  CANCELLED = "CANCELLED",
}

export enum BoxOfferRulePeriod {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}

export const BoxOfferValidity = {
  UNLIMITED: "UNLIMITED",
  DEFINED: "DEFINED",
} as const

export type BoxOfferValidity = (typeof BoxOfferValidity)[keyof typeof BoxOfferValidity]

export enum RecurringPeriod {
  WEEKLY = "P7D",
  BI_WEEKLY = "P14D",
  FOUR_WEEKLY = "P28D",
  MONTHLY = "P1M",
  BI_MONTHLY = "P2M",
  QUARTERLY = "P3M",
  SEMI_ANNUALLY = "P6M",
  ANNUALLY = "P1Y",
}

export const BoxOfferRuleSchema = z
  .object({
    value: z.number(),
    period: z.enum(BoxOfferRulePeriod),
  })
  .meta({ id: "BoxOfferRuleSchema" })

export const BoxOfferInvitationLinkSchema = z
  .object({
    boxId: z.string(),
    boxOfferId: z.string(),
    shortLink: z.string(),
  })
  .meta({ id: "BoxOfferInvitationLinkSchema" })

export type BoxOfferRule = z.infer<typeof BoxOfferRuleSchema>
export type BoxOfferInvitationLink = z.infer<typeof BoxOfferInvitationLinkSchema>
